import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  getCookieConsent,
  setCookieConsent,
  initGoogleAnalytics,
  revokeAnalytics,
} from '../utils/analytics';
import { useI18n } from '../i18n/I18nContext';
import './CookieBanner.css';

const LEGAL_PATHS = ['/datenschutz', '/impressum', '/en/privacy', '/en/legal-notice'];

const CookieBanner = () => {
  const { lang, copy } = useI18n();
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const isLegalPage = LEGAL_PATHS.includes(location.pathname);

  useEffect(() => {
    const consent = getCookieConsent();
    if (consent === null) {
      setIsVisible(true);
      return;
    }
    if (consent === 'accepted') {
      initGoogleAnalytics();
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent('accepted');
    initGoogleAnalytics();
    setIsVisible(false);
  };

  const handleDecline = () => {
    const hadAccepted = getCookieConsent() === 'accepted';
    setCookieConsent('declined');
    if (hadAccepted) {
      revokeAnalytics({ removeConsent: false, reload: false });
    }
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`michaela-cookie-banner-overlay${isLegalPage ? ' michaela-cookie-banner-overlay--legal' : ''}`}
    >
      <div className="michaela-cookie-banner-container">
        <div className="michaela-cookie-banner-content">
          <div className="michaela-cookie-banner-text">
            <h3 className="michaela-cookie-banner-title">{copy.cookie.title}</h3>
            <p className="michaela-cookie-banner-description">
              {copy.cookie.before}{' '}
              <Link to={lang === 'en' ? '/en/privacy' : '/datenschutz'} className="michaela-cookie-banner-link">{copy.cookie.link}</Link>
              {copy.cookie.after}
            </p>
          </div>

          <div className="michaela-cookie-banner-actions">
            <button
              type="button"
              className="michaela-cookie-banner-button michaela-cookie-banner-button-decline"
              onClick={handleDecline}
            >
              {copy.cookie.decline}
            </button>
            <button
              type="button"
              className="michaela-cookie-banner-button michaela-cookie-banner-button-accept"
              onClick={handleAccept}
            >
              {copy.cookie.accept}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
